import React, { useState } from "react";
import MideaViewer from "../../../../midea_viewer/MideaViewer";
// css comes in create_hw_finle.css
import axios from "../../../../axios";
import { iconData } from "../../../../iconData";
import { Player } from "video-react";
import { IP } from "./../../../../internalServer"

function CrossQueryAttachment({ attachment, setAttach, setAttachment2, attachMent2, indexToRemove }) {
  const [mideaviewer, setMideaviewer] = useState(false);
  const [isClicked, setIsClicked] = useState(false)
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  const handleRemoveAttachment = async () => {
    try {
      let res = await axios.delete(`/api/v1/file/delete`, {
        data: { file_path: attachment },
      });

      if (attachMent2 && attachMent2.length > 0) {
        const newArrayLimit = [...attachMent2];
        newArrayLimit.splice(indexToRemove, 1);
        setAttachment2(newArrayLimit)
      }

      res &&
        setAttach((prev) =>
          prev.filter((i) => {
            return i !== attachment;
          })
        );
    } catch (error) {
      console.log(error);
    }
  };
  const handleClick = (attachment) => {
    setResponseAttach(attachment)
    setIsClicked(!isClicked);
  };
  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment)
    setMideaviewer(true);
  };
  return (
    <>
      <div className="hw_defult_attach_box ml-3">
        <div className="d-flex align-items-center">
          <div
            className="d-flex align-items-center"
            onClick={() => {
              const fileType = attachment.split(".").pop();
              if (fileType === "jpg" || fileType === "jpeg" || fileType === "png" || fileType === "mp4"
                || fileType === "JPG" || fileType === "JPEG" || fileType === "PNG" || fileType === "MP4"
              ) {
                handleClick(attachment);
              } else if (fileType === "pdf" || fileType === "PDF" || fileType === 'ppt' || fileType === 'PPT' || fileType === 'PPTX' || fileType === 'pptx') {
                handleClickforpdf(attachment);
              }
            }}
          >
            <>
              {attachment.split(".").pop() === "jpg" ||
                attachment.split(".").pop() === "jpeg" ||
                attachment?.split(".").pop() === "JPEG" ||
                attachment?.split(".").pop() === "JPG" ||
                attachment?.split(".").pop() === "PNG" ||
                attachment?.split(".").pop() === "mp4" ||
                attachment?.split(".").pop() === "MP4" ||
                attachment.split(".").pop() === "png" ? (
                <div
                  // key={index}
                  onClick={() => {
                    if (!isError) {
                      handleClick(attachment);
                    }
                  }}
                  className="ContainerUploadedPdf d-flex gap-2 p-1"
                >
                  <div className="d-flex align-items-center pdf_logo">
                    <img
                      src={`${iconData?.find(
                        (i) => i.extension === attachment?.split(".").pop()
                      )?.icon
                        }`}
                      alt=""
                      className="attachLogoActivity"
                    />
                  </div>
                </div>
              ) : (
                <div className="d-flex align-items-center pdf_logo" onClick={() => handleClickforpdf(attachment)}>
                  <img
                    className="  attachLogoActivity"
                    src={`${iconData?.find(
                      (i) =>
                        i.extension ===
                        attachment?.match(/\.([^.]+)$/)[1]
                    )?.icon
                      }`}
                    alt=""
                  />
                </div>
              )}
            </>

            {/* <img
              className="mr-2 hw_defult_attach_type_icon"
              src={`${
                iconData?.find(
                  (i) =>
                    i.extension ===
                    attachment.substring(attachment.lastIndexOf(".") + 1)
                )?.icon
              }`}
              alt="icon"
            /> */}

            <span className="hw_default_attach_name">
              {attachment?.replace(/^[^_]*_/, "")}
            </span>
          </div>

          <img
            onClick={handleRemoveAttachment}
            src="/images/attachment_cross_icon.png"
            alt="icon"
          />
        </div>
      </div>
      {mideaviewer && (
        <MideaViewer
          closeMideaviewer={setMideaviewer}
          attachment={responseAttach}
        />
      )}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/images/cross.png"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {
                !isError ? (
                  <>
                    <img
                      className="imgMain"
                      src={IP + responseAttach?.replace(/^\./, "")}
                      alt="Full-size"
                      onError={(e) => {
                        setIsError(true)
                      }}
                    />
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/images/cross.png"
                        alt="Up Arrow"
                      />
                    </div>
                  </>
                ) : (
                  <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>
                    <img
                      onClick={() => {
                        handleClick()
                        setIsError(false)
                      }}
                      src="/images/cross.png"
                      alt="Up Arrow"
                      style={{ position: "absolute", top: "75px", right: "40%" }}
                    />
                    <img src="/images/no-photo-1.png" alt="img" style={{ width: "25%" }} />
                    <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                  </div>
                )
              }

            </div>
          </div>
        ))}
    </>
  );
}

export default CrossQueryAttachment;
